import { formattedListCls } from './formatted-list.style.js';
import { jsx } from 'react/jsx-runtime';

function FormattedList({
  children,
  sep,
  finalSep
}) {
  return /*#__PURE__*/jsx("span", {
    className: formattedListCls,
    children: children?.map((child, index) => /*#__PURE__*/jsx("span", {
      "data-sep": sep ?? ", ",
      "data-final-sep": finalSep ?? " og ",
      children: child
    }, index))
  });
}

export { FormattedList };
//# sourceMappingURL=formatted-list.js.map
